

const generateCSV = (title: string, trainingRequests: any[], users: any[], departments: any[]) => {
    const csvRows = [];
    const headers = [
        "User",
        "Course Name",
        "Start Date",
        "End Date",
        "Status",
        "Institution",
        "Comments",
        "Email",
        "Department",
        "Phone Number",
        "Supervisor",
        "Duration",
        "Purpose",
        "Date Requested",
    ];

    // Add the headers to the CSV
    csvRows.push(headers.join(","));

    // Utility functions
    const getUserName = (uid: string): string => {
        const user = users.find((user) => user.uid === uid);
        return user ? user.displayName || "Unknown User" : "Unknown User";
    };

    const getDepartmentName = (departmentId: string): string => {
        const department = departments.find((dept) => dept.asJson.id === departmentId);
        return department ? department.asJson.name : "Unknown Department";
    };

    const getSupervisorName = (uid: string): string => {
        const supervisor = users.find((user) => user.uid === uid);
        return supervisor ? supervisor.displayName || "Unknown Supervisor" : "Unknown Supervisor";
    };

    // Add data rows to the CSV
    trainingRequests.forEach((request) => {
        const row = [
            getUserName(request.uid),
            request.courseName,
            new Date(request.startDate).toLocaleDateString(),
            new Date(request.endDate).toLocaleDateString(),
            request.status,
            request.institution,
            request.comments,
            request.email,
            getDepartmentName(request.department),
            request.phoneNumber,
            getSupervisorName(request.supervisor),
            request.duration,
            request.purpose,
            new Date(request.dateRequested).toLocaleDateString(),
        ];
        csvRows.push(row.join(","));
    });

    // Create a Blob and download the CSV
    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `${title} ${new Date().toISOString()}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export default generateCSV;
